module.exports = __webpack_public_path__ + "static/media/six.7ed32683.svg";